// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2G1yk","container":"styles_container__2p9a-","title":"styles_title__305YD","wrapper":"styles_wrapper__1q5ZU","answer":"styles_answer__26iib"};